import React, { ReactNode } from 'react';
import { Stack } from 'react-bootstrap';
import { Link } from 'react-router-dom';

interface IconLinkProps {
  icon: ReactNode;
  text?: string;
  url?: string;
  children?: ReactNode;
  onclick?: () => void;
  target?: string;
}

export const IconLink: React.FC<IconLinkProps> = ({ icon, text, url, children, onclick, target }) => {
  return (
    <Stack
      direction="horizontal"
      gap={2}
      className="text-info py-1"
    >
      {icon}
      {text && (
        <Link
          className="text-info fw-semibold"
          style={{ maxWidth: '80%' }}
          to={url ?? ''}
          onClick={onclick}
          target={target}
          rel={target === '_blank' ? 'noopener noreferrer' : undefined}
        >
          {text}
        </Link>
      )}
      {children}
    </Stack>
  );
};
